<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-md-12 mb-1">
                    <label class="form-label">Başlangıç Bölgesi</label>
                    <v-select-list v-model="startRegion" v-on:input="getStoks" placeholder="Başlangıç Bölgesi" label="RegionName" :options="startRegions"/>   
                </div>
                <div class="col-md-12 mb-1">
                    <label class="form-label">Bitiş Bölgesi</label>
                    <v-select-list v-model="endRegion" placeholder="Bitiş Bölgesi" label="RegionName" :options="endRegions"/>   
                </div>
                <div class="col-md-12 mb-1">
                    <label class="form-label">Taşıma Tipi</label>
                    <v-select-list placeholder="Taşıma Tipi" v-model="transportStatus" label="Name" :options="vehicleTransportStatuses"/>
                </div>
                <div class="col-md-12 mb-1">
                    <label class="form-label">Stok</label>
                    <v-select-list :disabled="startRegion == null" v-model="stok" :options="stoks" label="Name" placeholder="Stok" :loading="stokLoading"></v-select-list>
                </div>
                <div class="col-md-12 mb-1">
                    <label class="form-label">Araç Tipi</label>
                    <v-select-list :options="vehicleTypes" v-model="vehicleType" placeholder="Araç Tipi" label="Name"></v-select-list>
                </div>
            </div>
        </div>
        <!-- Rota baz tarihi: sözleşme tarihinden bağımsızdır ve sözleşme ekranında gösterilmez.
             Kullanıcı mazot fiyatını elle yazmaz; tarihi listeden, o günün mazot fiyatını
             görerek seçer. Güncel fiyatın yürürlük tarihi de bu tarihtir; aynı tarih ikinci
             kez sorulmaz. -->
        <div class="col-12">
            <div class="d-flex align-items-center mb-50">
                <h5 class="mb-0">Rota Baz Tarihi <span class="text-danger">*</span></h5>
                <small class="text-muted ml-50">(fiyatın verildiği mazot seviyesi)</small>
            </div>
            <v-select-list
                v-model="fuelBase"
                placeholder="Baz tarih ve mazot fiyatı seçiniz"
                label="Label"
                :loading="fuelPricesLoading"
                :options="fuelPrices"/>
            <small v-if="!value.FuelBaseDate" class="text-danger">
                Rota kaydedilebilmesi için baz tarih seçilmelidir.
            </small>
        </div>

        <div class="col-12 mt-1">
            <table class="table table-sm table-bordered mb-0">
                <thead>
                    <tr>
                        <th class="text-center px-50">Sil</th>
                        <th class="w-50">Tarih</th>
                        <th class="w-50">Fiyat</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Geçmiş fiyat satırları: rotanın daha önceki fiyat seyri. Tarihleri
                         elle girilir ve baz tarihten önce olmak zorundadır. -->
                    <tr v-for="(r,i) in historyRows" :key="'h'+i">
                        <td class="p-25">
                            <button
                                class="btn btn-icon btn-sm btn-flat-danger"
                                v-on:click="removeHistoryRow(i)">
                                <feather-icon icon="TrashIcon"/>
                            </button>
                        </td>
                        <td>
                            <v-date-picker placeholder="Tarih" v-model="r.StartDate"></v-date-picker>
                        </td>
                        <td>
                            <v-currency-input input-class="text-right" :value="r.Price" v-on:update-value="currencyAmount => r.Price = currencyAmount"></v-currency-input>
                        </td>
                    </tr>

                    <!-- Güncel fiyat satırı: tarihi baz tarihten gelir, elle girilmez. -->
                    <tr v-if="currentRow">
                        <td class="p-25 text-center align-middle">
                            <feather-icon icon="LockIcon" size="14" class="text-muted"/>
                        </td>
                        <td class="align-middle">
                            <span v-if="fuelBase">
                                {{ fuelBase.DateStr }}
                                <b-badge variant="light-primary" class="ml-25">Baz</b-badge>
                            </span>
                            <small v-else class="text-muted">Baz tarih seçiniz</small>
                        </td>
                        <td>
                            <v-currency-input input-class="text-right" :value="currentRow.Price" v-on:update-value="currencyAmount => currentRow.Price = currencyAmount"></v-currency-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="100" class="p-25">
                            <button v-on:click="addHistoryRow" class="btn btn-secondary btn-sm w-100">Geçmiş Fiyat Ekle</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="col-12 mt-2">
            <hr class="mt-0"/>
            <v-executer
                full-width
                variant="primary"
                :action="calculate"
                :loading="calculating"
                :disabled="!canCalculate">
                Güncel Fiyatı Hesapla
            </v-executer>

            <div v-if="baseDateWarning" class="alert alert-warning p-1 mb-1 mt-1">
                <small>{{ baseDateWarning }}</small>
            </div>

            <div v-if="simulation" class="mt-50">
                <div v-if="simulation.InactiveReason" class="alert alert-warning p-1 mb-1">
                    <small>
                        {{ simulation.InactiveReason }}
                        Bu sözleşmede mazot kaynaklı otomatik zam çalışmadığı için fiyat
                        girildiği gibi kaydedilecek.
                    </small>
                </div>
                <template v-else>
                    <div class="row mb-1">
                        <div class="col-md-3"><small class="text-muted d-block">Baz Mazot</small><b>{{ simulation.BaseFuelPriceStr }} ₺</b></div>
                        <div class="col-md-3"><small class="text-muted d-block">Güncel Mazot</small><b>{{ simulation.CurrentFuelPriceStr }} ₺</b></div>
                        <div class="col-md-3"><small class="text-muted d-block">Girilen Fiyat</small><b>{{ simulation.StartPriceStr }} ₺</b></div>
                        <div class="col-md-3">
                            <small class="text-muted d-block">Güncel Fiyat</small>
                            <b class="text-primary">{{ simulation.FinalPriceStr }} ₺</b>
                            <small class="ml-25">({{ simulation.TotalChangeRateStr }})</small>
                        </div>
                    </div>

                    <div v-if="(simulation.Steps || []).length === 0" class="alert alert-success p-1 mb-0">
                        <small>Baz tarihten bugüne eşiği aşan bir mazot değişimi olmamış. Fiyat aynen kaydedilecek.</small>
                    </div>
                    <div v-else class="table-responsive mb-0">
                        <small class="text-muted d-block mb-25">
                            Kayıt anında aşağıdaki ara zamlar geriye dönük olarak oluşturulacaktır.
                        </small>
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th class="text-nowrap">Tarih</th>
                                    <th class="text-nowrap text-right">Mazot</th>
                                    <th class="text-nowrap text-right">Değişim</th>
                                    <th class="text-nowrap text-right">Eski Fiyat</th>
                                    <th class="text-nowrap text-right">Yeni Fiyat</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s,i) in simulation.Steps" :key="i">
                                    <td class="text-nowrap">{{ s.DateStr }}</td>
                                    <td class="text-nowrap text-right">{{ s.PreviousFuelPriceStr }} → {{ s.FuelPriceStr }}</td>
                                    <td class="text-nowrap text-right">{{ s.FuelChangeRateStr }}</td>
                                    <td class="text-nowrap text-right">{{ s.OldPriceStr }}</td>
                                    <td class="text-nowrap text-right font-weight-bolder">{{ s.NewPriceStr }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { SystemDataApi } from '@/api/system-data'
import {VehicleTypeApi} from '@/api/vehicle-type'
import {TransferRegionApi} from '@/api/transfer-region'
import {MaterialApi} from '@/api/material'
import {FuelPriceApi} from '@/api/fuel-price'
import {AgreementApi} from '@/api/agreement'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import VExecuter from '@/components/VExecuter.vue'
import { BBadge } from 'bootstrap-vue'
import moment from 'moment'

export default {
    components:{
        VCurrencyInput,
        VExecuter,
        BBadge
    },
    props:{
        value:Object
    },
    data(){
        return {
            startRegions:[],
            endRegions:[],
            stoks:[],
            vehicleTransportStatuses:[],
            vehicleTypes:[],
            stokLoading:null,
            fuelPrices:[],
            fuelPricesLoading:false,
            simulation:null,
            calculating:false
        }
    },
    mounted(){
        this.getRegions()
        this.getVehicleTransportStatuses()
        this.getVehicleTypes()
        this.getFuelPrices()
    },
    watch:{
        // Baz tarih ya da fiyat değiştiğinde önceki hesap geçersizdir; kullanıcının
        // eski sonuca bakarak kaydetmesini engellemek için önizleme temizlenir.
        'value.FuelBaseDate'(value){
            this.simulation = null
            // Güncel fiyatın yürürlük tarihi baz tarihtir; kullanıcı aynı tarihi iki kez
            // girmesin diye satırın tarihi buradan beslenir.
            if(this.currentRow)
                this.currentRow.StartDate = value
        },
        lastPrice(){
            this.simulation = null
        },
        // Baz tarih doğrulaması üst ekrana bildirilir; kaydet düğmesi buna göre kapanır.
        baseDateWarning:{
            immediate:true,
            handler(value){
                this.$emit('validation',value)
            }
        }
    },
    methods:{
        getFuelPrices(){
            this.fuelPricesLoading = true
            FuelPriceApi.List().then(res=>{
                this.fuelPrices = res.data.Data || []
                this.fuelPricesLoading = false
            }).catch(err=>{
                console.error(err)
                this.fuelPricesLoading = false
            })
        },
        calculate(){
            if(!this.canCalculate)
                return

            this.calculating = true
            this.simulation = null
            AgreementApi.SimulateRoute({
                AgreementId: this.value.AgreementId,
                FuelBaseDate: this.value.FuelBaseDate,
                Price: this.lastPrice
            }).then(res=>{
                if(res.data.Success)
                    this.simulation = res.data.Data
                else
                    this.$result(res)
                this.calculating = false
            }).catch(err=>{
                this.$result(null,err)
                this.calculating = false
            })
        },
        getVehicleTypes(){
            VehicleTypeApi.List().then(res => {
                this.vehicleTypes = res.data.Data
            }).catch(err=> {
                console.error(err)
            })
        },
        getRegions(){
            TransferRegionApi.List().then(res=>{
                this.startRegions = res.data.Data
                this.endRegions = res.data.Data
            })
        },
        getStoks(){
            if(this.value.StartRegionId){
                this.stoks = []
                this.stokLoading = true
                MaterialApi.ListByRegion(this.value.StartRegionId).then(res => {
                    this.stoks = res.data.Data
                    this.stokLoading = false
                }).catch(err=> {
                    console.log(err)
                    this.stokLoading = false
                })
            }
        },
        getVehicleTransportStatuses(){
            SystemDataApi.VehicleTransportStatuses().then(res=> {
                this.vehicleTransportStatuses = res.data.Data
            })
        },
        // Geçmiş fiyat satırı her zaman güncel fiyat satırından önce durur; dizinin son
        // elemanı güncel fiyat olarak sabit kalır.
        addHistoryRow(){
            const rows = this.value.RoutePrices
            rows.splice(Math.max(rows.length - 1, 0), 0, {StartDate:null, Price:null})
        },
        removeHistoryRow(index){
            this.$delete(this.value.RoutePrices, index)
        }
    },
    computed:{
        stok:{
            get:function(){
                return this.stoks.find(s=>s.Code==this.value.StockCode)
            },
            set:function(value){
                this.value.StockCode = value?.Code || null
                this.value.StockName = value?.Name || null
            }
        },
        vehicleType:{
            get:function(){
                return this.vehicleTypes.find(s=>s.Id==this.value.VehicleTypeId)
            },
            set:function(value){
                this.value.VehicleTypeName = value?.Name || null
                this.value.VehicleTypeId = value?.Id || null
            }
        },
        transportStatus:{
            get:function(){
                return this.vehicleTransportStatuses.find(b=>b.Value==this.value.Status)
            },
            set:function(value){
                this.value.Status = value == null ? null : value.Value 
            }
        },
        startRegion:{
            get:function(){
                return this.startRegions.find(b=>b.Id==this.value.StartRegionId)
            },
            set:function(value){
                this.value.StartRegionId = value?.Id || null
            }
        },
        endRegion:{
            get:function(){
                return this.endRegions.find(b=>b.Id==this.value.EndRegionId)
            },
            set:function(value){
                this.value.EndRegionId = value?.Id || null
            }
        },
        // Dizinin son elemanı güncel fiyat, öncekiler geçmiş fiyat seyri.
        currentRow(){
            const rows = this.value.RoutePrices || []
            return rows.length ? rows[rows.length - 1] : null
        },
        historyRows(){
            const rows = this.value.RoutePrices || []
            return rows.slice(0, Math.max(rows.length - 1, 0))
        },
        fuelBase:{
            get:function(){
                if(!this.value.FuelBaseDate)
                    return null
                return this.fuelPrices.find(f => moment(f.Date).isSame(moment(this.value.FuelBaseDate),'day')) || null
            },
            set:function(value){
                this.value.FuelBaseDate = value == null
                    ? null
                    : moment(value.Date).format('YYYY-MM-DD')
            }
        },
        // Geriye dönük hesap, baz tarihte geçerli olan güncel fiyat üzerinden yürür.
        lastPrice(){
            return this.currentRow ? this.currentRow.Price : null
        },
        canCalculate(){
            return this.value.AgreementId != null
                && this.value.FuelBaseDate != null
                && this.lastPrice != null
                && this.baseDateWarning == null
        },
        baseDateWarning(){
            if(!this.value.FuelBaseDate)
                return null

            const base = moment(this.value.FuelBaseDate)
            if(base.isAfter(moment(),'day'))
                return 'Rota baz tarihi bugünden ileri bir tarih olamaz.'

            // Geçmiş fiyat satırları güncel fiyattan önce gelmek zorunda; aksi halde
            // sunucudaki sıralama güncel fiyatı en sonda kabul edemez.
            const invalid = this.historyRows.some(r => r.StartDate && !moment(r.StartDate).isBefore(base,'day'))
            if(invalid)
                return 'Geçmiş fiyat tarihleri, rota baz tarihinden önce olmalıdır.'

            return null
        }
    }
}
</script>